var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1111 6.44444V4.88889C11.1111 2.74112 9.37 1 7.22222 1C5.07445 1 3.33333 2.74111 3.33333 4.88889V6.44444M7.22222 9.94444V11.5M4.73333 15H9.71111C11.0179 15 11.6713 15 12.1704 14.7457C12.6095 14.522 12.9664 14.165 13.1901 13.726C13.4444 13.2269 13.4444 12.5735 13.4444 11.2667V10.1778C13.4444 8.87099 13.4444 8.21759 13.1901 7.71847C12.9664 7.27942 12.6095 6.92247 12.1704 6.69876C11.6713 6.44444 11.0179 6.44444 9.71111 6.44444H4.73333C3.42654 6.44444 2.77315 6.44444 2.27402 6.69876C1.83498 6.92247 1.47802 7.27942 1.25432 7.71847C1 8.21759 1 8.87099 1 10.1778V11.2667C1 12.5735 1 13.2269 1.25432 13.726C1.47802 14.165 1.83498 14.522 2.27402 14.7457C2.77315 15 3.42654 15 4.73333 15Z",
    stroke: "#98A2B3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.43b26fbb390b25af6b63f4e3f6206380.svg";
export { ForwardRef as ReactComponent };